import { useMutation, useQuery } from '@tanstack/react-query';
import axiosInstance from '../axios';

// Interface based on your API response structure
export interface PendingApprovalData {
    requisition: number;
    purchaseIndent: number;
    purchaseOrder: number;
    purchaseBill: number;
    chequeSignature: number;
    paymentVerification: number;
    modifyPORequest: number;
    attendanceRequest: number;
}

export interface PendingApprovalResponse {
    status: boolean;
    message: string;
    data: PendingApprovalData;
}

/**
 * Fetch Pending Approval Counts (No Payload)
 * Path: /util/getPendingApprovalCounts
 */
const getPendingApprovalCounts = async (): Promise<PendingApprovalData> => {
    // Calling the endpoint with an empty object or no body as per your requirement
    const response = await axiosInstance.post<PendingApprovalResponse>(
        '/util/getPendingApprovalCounts'
    );
    return response.data.data;
};

// Hook for automatic fetching (Best for Sidebar badges or Dashboard Headers)
export const useGetPendingApprovalCounts = () => {
    return useQuery<PendingApprovalData, Error>({
        queryKey: ['getPendingApprovalCounts'],
        queryFn: getPendingApprovalCounts,
        refetchOnWindowFocus: true, 
        staleTime: 1000 * 60,       
    });
};

// Hook for manual triggering (Best for a "Refresh" button)
export const useGetPendingApprovalCountsMutation = () => {
    return useMutation<PendingApprovalData, Error>({
        mutationKey: ['getPendingApprovalCountsMutation'],
        mutationFn: getPendingApprovalCounts,
    });
};